<template>
    <div class="citypanel">
        <p class="p-title">城市列表（支持汉字/拼音）</p>
        <div class="hot-cities">
            <a class="hot-city" v-for="(hot, idx) in hotList" :key="hot.code" @click="selectHot(idx)">{{hot.city}}</a>
        </div>
        <div class="nav-box">
            <div class="nav-bar">
                <span class="nav-item" :class="{ on: listType == 1 }" @click="changeType(1)">按省份</span>
                <span class="nav-item" :class="{ on: listType == 2 }" @click="changeType(2)">按城市</span>
            </div>
            <div class="city-search-box" v-click-outside="closeList">
                <input type="text" class="city-input" placeholder="输入城市名" v-model="cityInput" @focus="inputFocus" @input="searchCity(false)" @keydown.enter="selectCity(0)">
                <a class="btn-city-search" @click="searchCity(true)">搜索</a>
                <div class="result-list" @mouseenter="selectIdx = -1" @mouseleave="selectIdx = 0" v-show="searchList.length > 0">
                    <span class="r-item" :class="{on: selectIdx == idx}" v-for="(city, idx) in searchList" :key="city.code" @click="selectCity(idx)">{{city.city}}</span>
                </div>
            </div>
        </div>
        <div class="nav-container">
            <div class="initial-nav">
                <a class="link" v-for="short in initialList" :key="short" @click="scrollToIndex(short)">{{ short }}</a>
            </div>
            <div class="city-container">
                <ul class="city-list p" v-if="listType == 1">
                    <li class="cities" v-for="(p, idx) in provinces" :key="`${p.initial}_${idx}`">
                        <span class="initial" :data-index="p.initial">{{ p_navInfo[p.initial] == idx ? p.initial : '' }}</span>
                        <a class="province" @click="selectCity2(p.code)">{{p.name}}</a>
                        <div class="city-box">
                            <a v-for="c in p.cities" :key="c.code" @click="selectCity2(c.code)">{{c.city}}</a>
                        </div>
                    </li>
                </ul>
                <ul class="city-list c" v-if="listType == 2">
                    <li class="cities" v-for="(cities, idx) in cityList" :key="initialList[idx]">
                        <span class="initial" :data-index="initialList[idx]">{{initialList[idx]}}</span>
                        <div class="city-box">
                            <a v-for="c in cities" :key="c.cities.code" @click="selectCity2(c.cities.code)">{{c.cities.city}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<style src="./citypanel.css"></style>

<script>
import cityInfo from './citydata.js';
import clickOutside from './outside.js';
const reg = /^[A-Z]$/;
let cityBoxDom;

export default {
    directives: { clickOutside },
    data () {
        return {
            hotList: [],
            cityInput: '',
            initialList: [],
            provinces: [],
            cityList: [],
            listType: 1,
            pinyin: '',
            p_navInfo: {},
            searchList: [],
            selectIdx: 0
        }
    },
    watch: {
        listType (val, oldVal) {
            if(val == oldVal){ return; }
            this.initialList = cityInfo.getInitials(val);
        }
    },
    mounted () {
        this.hotList = cityInfo.getHotCities();
        this.initialList = cityInfo.getInitials(this.listType);
        let info = cityInfo.getProvinceData();
        this.provinces = info.list;
        this.p_navInfo = info.navInfo;
        this.cityList = cityInfo.getCityList();
        cityBoxDom = document.querySelector('.city-container');
    },
    methods: {
        changeType (val) {
            if(![1,2].includes(val)){ return; }
            this.listType = val;
        },
        closeList (e) {
            this.searchList = [];
        },
        selectHot (idx) {
            let city = this.hotList[idx];
            this.$emit('selected', JSON.parse(JSON.stringify(city)));
        },
        inputFocus () {
            if(!this.cityInput){ return; }
            this.searchCity();
        },
        searchCity (flag) {
            this.selectIdx = 0;
            let word = this.cityInput.trim();
            if(/^[a-z]+$/i.test(word) && word.length < 2){ return (this.searchList = []); }
            let list = cityInfo.getCitiesByPinyin(word);
            this.searchList = list;
        },
        selectCity (idx) {
            if(this.searchList.length == 0){ return; }
            let city = this.searchList[idx];
            if(!city){ return; }
            this.$emit('selected', JSON.parse(JSON.stringify(city)));
            this.cityInput = city.city;
            this.searchList = [];
            this.selectIdx = 0;
        },
        selectCity2 (code) {
            if(code === '90'){ return; }
            let city = cityInfo.getCityByCode(code);
            if(!city){ return; }
            this.$emit('selected', JSON.parse(JSON.stringify(city)));
        },
        scrollToIndex (idx) {
            if(!idx){ return; }
            let target = cityBoxDom.querySelector(`.initial[data-index="${idx}"]`);
            if(!target){ return; }
            let box = cityBoxDom.querySelector('.city-list');
            let s_height = target.offsetTop - box.scrollTop;
            box.scrollTop += s_height;
        }
    }
}
</script>
